<app-header [title]="'SETTINGS-PAGE.HEADER.TITLE' | transloco" [withIcon]="true"/>
<div class="content">
  @for (key of currenSettingKeys; track key) {
    @let option = currentSettings[key];
    <app-settings-option [option]="option" (click)="initPopup(option)"/>
  }
</div>
<app-popup [(isOpen)]="isOpen" [dynamicComponent]="SettingsPopupComponent" [data]="popupData" [from]="slideInFrom"/>
